import { ProjetosContext } from 'contexts/projetos/ProjetosContext';
import { EtapaProjeto } from 'models/projeto';
import TitleEtapa from 'pages/FluxoProjetos/Components/titleEtapa/titleEtapa';
import { useContext, useEffect, useLayoutEffect } from 'react';
import EtapasRevisao from '../campos/etapasRevisao';
import Visualizado from '../campos/visualizado';
import styles from './etapas.scss';
const { rootClassName } = styles;

const etapa = EtapaProjeto.revisao;
export const REVISAO_SCROLL_ID = 'revisao-scrollable-container';
export default function RevisaoFinalizacao() {
  const {
    dispatch,
    state: { projeto, loading },
    loadAssessores,
    loadCooperativas,
    loadEducadores,
    loadEtapasEducacao,
    loadInstituicoes,
    loadModalidades,
    loadPrincipiosValores,
  } = useContext(ProjetosContext);

  useLayoutEffect(() => {
    dispatch({
      type: 'setEtapa',
      payload: etapa,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!loading) {
      Promise.all([
        loadCooperativas(),
        loadInstituicoes(),
        loadEtapasEducacao(),
        loadModalidades(),
        loadPrincipiosValores(),
        loadAssessores(projeto.codigoCooperativa),
        loadEducadores(projeto.idEscola),
      ]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading]);

  return (
    <div className={rootClassName}>
      <TitleEtapa etapa={etapa} />
      <Visualizado chave='checkProfGestor' />
      <Visualizado chave='checkCoordenador' />
      <hr />
      <div id={REVISAO_SCROLL_ID} className={`${rootClassName}-scrollable`}>
        <EtapasRevisao />
      </div>
    </div>
  );
}
